module.exports = __webpack_public_path__ + "static/media/03_hero_tablet.37f9393a.jpg";